const _0 = "0"
const _1 = "1"
const _2 = "2"
const config = { "0": _0, "1": _1, "2": _2,  }
export { config as default, _0, _1, _2 }